import React, { memo } from "react";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

function AppFooter({ height = "2.5rem" }) {
  const theme = useTheme();

  return (
    <Box
      sx={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        height,

        display: "flex",
        alignItems: "center",
        px: 2,

        backgroundColor: theme.palette.background.paper,
        borderTop: "1px solid rgba(255,255,255,0.1)",
        zIndex: 900,
      }}
    >
      <Typography variant="caption" color="text.secondary">
        powered by: ksb-it
      </Typography>
    </Box>
  );
}

export default memo(AppFooter);
